import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';
import type { GlslImageReference } from '@/types/node';
import type { GlslSpec } from 'web';

export const MAX_CUSTOM_GLSL_PROMPT_CHARS = 4000;
export const CUSTOM_GLSL_GENERATION_COST = 10;

export interface GenerateGlslArgs {
  inputType: 'image' | 'video';
  prompt: string;
  imageReferences?: GlslImageReference[];
  signal?: AbortSignal;
}

// The server augments the WASM `GlslSpec` with a suggested node display name.
// The name is client-side node state (data.name), so it is not part of the WASM type.
export type GeneratedGlslResponse = GlslSpec & { name: string };

export async function generateCustomGlslSpec({
  inputType,
  prompt,
  imageReferences,
  signal,
}: GenerateGlslArgs): Promise<GeneratedGlslResponse> {
  const res = await safeAxios.post<GeneratedGlslResponse>(
    API_ROUTES.customEffects.glsl(),
    { inputType, prompt, imageReferences },
    { signal },
  );
  return res.data;
}
